<div
  class="fixed inset-0 bg-bg-alt/80 backdrop-blur-sm transition-opacity z-[60]"
  [ngClass]="{ hidden: state() === 'inactive' }"
></div>
<div [@fadeInOut]="state()" class="fixed inset-0 overflow-hidden z-[60]">
  <div class="absolute inset-0 overflow-hidden">
    <div
      class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10"
    >
      <div class="pointer-events-auto w-screen max-w-md">
        <div class="flex h-full flex-col overflow-y-scroll bg-bg shadow-xl">
          <div class="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
            @if (shoppingCart().totalItems > 0) {
              <div
                class="flex items-start justify-between border-b border-border"
              >
                <h2 class="text-lg font-medium text-fg">Carrito de compras.</h2>
                <div class="ml-3 flex h-7 items-center mb-4">
                  <button
                    type="button"
                    class="relative text-fg-subtle hover:text-fg-subtle"
                    (click)="toggle()"
                  >
                    <span class="absolute inset-0.5"></span>
                    <span class="sr-only">Close panel</span>
                    <svg
                      class="h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>

              <div class="mt-8">
                <div class="flow-root">
                  <ul role="list" class="-my-6 divide-y divide-border">
                    @for (item of shoppingCart().items; track $index) {
                      <li class="flex py-6">
                        <a
                          class="h-25 sm:w-25 w-20 flex-shrink-0 overflow-hidden rounded-md border border-border bg-bg-alt"
                          [routerLink]="[
                            '/productos/creatinas',
                            item.product.slug,
                          ]"
                        >
                          <img
                            [ngSrc]="
                              item.product.imageUrl === ''
                                ? './assets/images/product-default-image.jpeg'
                                : item.product.imageUrl!
                            "
                            [alt]="item.product.name"
                            height="94"
                            width="94"
                            class="h-full w-full object-cover object-center"
                          />
                        </a>

                        <div class="ml-3 flex flex-1 flex-col">
                          <div>
                            <div
                              class="flex justify-between font-light text-sm text-fg text-pretty mb-2"
                            >
                              <a
                                [routerLink]="[
                                  '/productos/creatinas',
                                  item.product.slug,
                                ]"
                                routerLinkActive="router-link-active"
                                class="max-w-[70%] hover:underline hover:text-primary-hover"
                              >
                                {{ item.product.name.trim() }}
                              </a>
                              @if (
                                item.product.is_on_sale &&
                                item.product.discountPercentage
                              ) {
                                <!-- precio con descuento -->
                                <p class="ml-3">
                                  {{
                                    item.product.price
                                      | discount
                                        : item.product.discountPercentage
                                      | currency: "S/ "
                                  }}
                                </p>
                              } @else {
                                <!-- Cuando no hay descuento -->
                                <p class="ml-3">
                                  {{ item.product.price | currency: "S/ " }}
                                </p>
                              }
                            </div>
                          </div>
                          <div
                            class="flex flex-1 items-end justify-between text-sm"
                          >
                            <app-product-quantity
                              [predeterminedQuantity]="item.quantity"
                              (quantityValue)="quantityValue($event, item)"
                            />

                            <div class="flex">
                              <button
                                (click)="deleteItemFromCart(item)"
                                type="button"
                                class="font-medium"
                                [ngClass]="[TextColorClass, TextHoverClass]"
                              >
                                Eliminar
                              </button>
                            </div>
                          </div>
                        </div>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            } @else {
              <div class="flex items-start justify-between">
                <h2
                  class="text-lg font-medium text-fg"
                  aria-label="Carrito de compras"
                ></h2>
                <div class="ml-3 flex h-7 items-center">
                  <button
                    type="button"
                    class="relative text-fg-subtle hover:text-fg-subtle"
                    (click)="toggle()"
                  >
                    <span class="absolute inset-0.5"></span>
                    <span class="sr-only">Close panel</span>
                    <svg
                      class="h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div
                class="flex flex-col gap-5 h-full justify-center items-center"
              >
                <ml-icon
                  name="shopping-cart"
                  class="h-16 w-16 text-fg-subtle"
                />
                <p class="font-medium">Tu carro está vacío.</p>
              </div>
            }
          </div>

          <div class="border-t border-border px-2 py-2 sm:px-6 sm:py-6">
            @if (shoppingCart().totalItems > 0) {
              <div class="flex justify-between text-base font-medium text-fg">
                <p>Subtotal ({{ shoppingCart().totalItems }})</p>
                <p>{{ shoppingCart().subTotal | currency: "S/ " }}</p>
              </div>
              <!-- <p class="mt-0.5 text-sm text-fg-subtle">Shipping and taxes calculated at checkout.</p> -->
              <div class="mt-6 flex flex-col gap-2">
                <!-- <a href="#" class="flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700">
                  Ir al carro
                </a> -->
                <ml-button
                  [routerLink]="['/bolsa']"
                  (click)="toggle()"
                  name="Ir al carro"
                  type="secondary-outlined"
                ></ml-button>
                <ml-button
                  name="Finalizar compra &rarr;"
                  (click)="goCheckout()"
                ></ml-button>
              </div>
            } @else {
              <div class="flex flex-col gap-2">
                @if (!isProductPage) {
                  <ml-button
                    type="primary"
                    [routerLink]="['/productos']"
                    name="Ir a comprar &rarr;"
                    (click)="toggle()"
                  ></ml-button>
                }
                <ml-button
                  [type]="isProductPage ? 'secondary' : 'secondary-outlined'"
                  class="w-[100%]"
                  name="Cerrar"
                  (click)="toggle()"
                ></ml-button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
